var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M38.9,0H6.5v60h47V14.6L38.9,0z M39.5,3.4L50.1,14H39.5V3.4z M8.5,58V2h29v14h14v42H8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M16.5,17h9c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1C15.5,16.6,15.9,17,16.5,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M33.5,37h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17c0.6,0,1-0.4,1-1S34.1,37,33.5,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M43.5,30h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c0.6,0,1-0.4,1-1S44.1,30,43.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M16.5,25h5c0.6,0,1-0.4,1-1s-0.4-1-1-1h-5c-0.6,0-1,0.4-1,1S15.9,25,16.5,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M31.5,25h7c0.6,0,1-0.4,1-1s-0.4-1-1-1h-7c-0.6,0-1,0.4-1,1S30.9,25,31.5,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M25.5,24c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7 c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4,0C25.6,23.5,25.5,23.7,25.5,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M21.5,30c-0.6,0-1,0.4-1,1s0.4,1,1,1h10c0.6,0,1-0.4,1-1s-0.4-1-1-1H21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M16.5,32c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4,0 c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7C16,31.9,16.2,32,16.5,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M43.5,44h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c0.6,0,1-0.4,1-1S44.1,44,43.5,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M31.5,44h-10c-0.6,0-1,0.4-1,1s0.4,1,1,1h10c0.6,0,1-0.4,1-1S32.1,44,31.5,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M15.8,44.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7C16.8,43.9,16.2,43.9,15.8,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M42.8,23.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7C43.8,22.9,43.2,22.9,42.8,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M39.2,38.7c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4,0c-0.2,0.2-0.3,0.4-0.3,0.7 c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3S39,38.9,39.2,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_document",
    d: "M42.8,37.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7C43.8,36.9,43.2,36.9,42.8,37.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDocument);
export default __webpack_public_path__ + "static/media/content_document.e093cb960baf721891e091d6ee8703aa.svg";
export { ForwardRef as ReactComponent };